import {
  HOME_CARE_SOLUTIONS,
  MEDICAL_SUPPLIES_SOLUTIONS,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_MOBILE_CARE,
} from "core/consts";
import {
  isPsychCareSearch,
  shouldRedactHouseNumber,
} from "core/model/auctions";
import {
  type AssessmentSolutionsInput,
  normalizeAssessmentSolutions,
} from "core/schemas/assessment";
import type { SearchType, Solutions } from "core/types";

const HOUSE_NUMBER_SOLUTIONS = [
  SOLUTION_MOBILE_CARE,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  ...MEDICAL_SUPPLIES_SOLUTIONS,
  ...HOME_CARE_SOLUTIONS,
] as Solutions;

export function requiredHouseNumber({
  search_type,
  share_patient_data_automatically,
  solutions,
}: {
  search_type: SearchType | null | undefined;
  share_patient_data_automatically: boolean | null | undefined;
  /** Normalized by {@link assessmentSolutionsSchema} on step payloads. */
  solutions?: AssessmentSolutionsInput;
}): boolean {
  const normalizedSolutions = normalizeAssessmentSolutions(solutions);
  if (
    shouldRedactHouseNumber({
      search_type: search_type ?? undefined,
      share_patient_data_automatically: share_patient_data_automatically ?? false,
    })
  ) {
    return true;
  }

  if (normalizedSolutions.length === 0) {
    return false;
  }

  if (isPsychCareSearch(search_type ?? undefined)) {
    return true;
  }

  return !normalizedSolutions.every(
    (s) => HOUSE_NUMBER_SOLUTIONS.indexOf(s) < 0,
  );
}
